import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-invoice-ok",
  "use": "icon-invoice-ok-usage",
  "viewBox": "0 0 17 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 14\" id=\"icon-invoice-ok\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.029.2a1 1 0 0 1 .2 1.4L7.987 12.59a2 2 0 0 1-3.136.08L.66 7.64a1 1 0 1 1 1.536-1.28l4.19 5.029L14.63.4a1 1 0 0 1 1.4-.2Z\" fill=\"#4066D4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol